<template>
<div style="height: 100%;">
	<div class="rms-container">
		<el-collapse v-model="activeNames" v-if="pageFlag">
			<el-collapse-item title="RMS应收管理" name="1">
				<div class="item" v-for="(item,index) in navList" :key="index" @click="navToClick(item)">
					<div class="img"><img src="@/assets/bms.png" alt=""></div>
					<div class="text">{{ item.label }}</div>
				</div>
			</el-collapse-item>
		</el-collapse>
	</div>
	<!-- 水印 -->
	<v-Watermark v-if="watermarkContent" :content="watermarkContent"></v-Watermark>
</div>
</template>

<script>
import Watermark from '../../../components/RMS/watermark';
import h5LoginMixin from './loginMixin';
export default {
name: "RMSH5",
mixins: [h5LoginMixin],
components:{
	'v-Watermark':Watermark,
},
data () {
	return {
		pageFlag: false,
		activeNames: ['1'],
		navList: [
			{
				label: '已送货未开票',
				mobileUrl: '/RMS/H5/list?type=1',
				PCUrl: '/RMS/invoicedAndShipped',
			},
			{
				label: '已开票未回款',
				mobileUrl: '/RMS/H5/list?type=2',
				PCUrl: '/RMS/invoicedAndShipped',
			},
		],
		formInline: {
			emClientType: sessionStorage.getItem("EMCLIENTTYPE"),
      wxId: sessionStorage.getItem("WXID"),
    },
		watermarkContent: null,  //水印
	};
},
created() {
    // mixin 的 created 已处理登录逻辑，已登录会自动调用 onLoginSuccess
  },
methods: {
  // 登录成功后执行（由 mixin 统一触发，不会重复）
  onLoginSuccess() {
    document.title = '工作台';
    this.pageFlag = true;

    this.watermarkContent = sessionStorage.getItem("NICKNAME") + (sessionStorage.getItem("MOBILE").toString()!='null' ? sessionStorage.getItem("MOBILE").slice(-4) : '');

    this.$store.dispatch("getTopLists", 1);
    this.$store.dispatch("getTopLists", 3);
    this.$store.dispatch("getTopLists", 4);
    this.$store.dispatch("getTopLists", 7);
    this.$store.dispatch("getTopLists", 10);
    this.$store.dispatch("getTopLists", 11);
    this.$store.dispatch("getTopLists", 13);
    this.$store.dispatch("getTopLists", 18);

    this.queryPrivileges();

    this.$router.replace({
      path: '/RMS/H5'
    });
  },
	// 查询用户权限
	async queryPrivileges(){
		let res = await this.$api.queryPrivileges();
		if (res.code === 200) {
			sessionStorage.setItem("PRIVILEGES", JSON.stringify(res.result));
		};
	},
	// 切换页面
	navToClick(obj){
		let url = obj.mobileUrl;
		if(this.formInline.emClientType=='PC'){
			url = obj.PCUrl;
		};
		location.href = window.location.origin + url;
	},
}
};
</script>
<style lang="less" scoped>
.rms-container {
	position: relative;
	z-index: 2;
	.el-collapse {
		border: none;
	}
	.el-collapse-item {
		box-shadow: 0 2px 8px rgba(0,0,0,0.1);
		margin-bottom: 15px;
		/deep/.el-collapse-item__header {
			border-bottom-color: #EBEEF5;
			padding: 0 10px;
			font-weight: bold;
		}
		/deep/.el-collapse-item__content {
			padding: 10px 0;
			overflow: hidden;
		}
	}
	.item {
		width: calc(~'33.33333333% - 20px');
		margin: 10px;
		float: left;
		text-align: center;
		.img {
			width: 80%;
			max-width: 50px;
			margin: 0 auto;
			border-radius: 10px;
			overflow: hidden;
			img {
				width: 100%;
				vertical-align: top;
			}
		}
		.text {
			height: 20px;
			line-height: 20px;
			margin-top: 5px;
			font-size: 12px;
		}
	}
}
</style>
